import { IconButton, Link, Popover } from '@one-thd/sui-atomic-components';
import { More } from '@one-thd/sui-icons';
import React, { SetStateAction, useState } from 'react';
import { IPHTabeMenu } from '../../../models/purchase-history/table';
import { routeBuilder } from '../../../utils/general';
import { putAccountIdValueInSessionStorage } from '../../../utils/shared/accountIdValueStorage';
import { ExportButton } from '../../shared/ExportButton';
import { PrintButton } from '../../shared/PrintButton';
import { ViewReceipt } from '../../shared/ViewReceipt/ViewReceipt';
import './ButtonGroup.scss';

export const PHTableMenu = ({
  accountIdValue,
  accountIdType,
  customerType,
  enableReceipt,
  encryptedReceiptRequest,
  orderDetailsData,
  orderNumber,
  orderOrigin,
  orderParams,
  receiptImageSting,
  enableExportAndPrint = true,
  setAlertState,
}: IPHTabeMenu) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: { currentTarget: SetStateAction<null> }) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const orderDetailsUrl = `/myaccount/order-details${routeBuilder(
    orderParams,
  )}`;
  const orderDetailsOrderNumber =
    new URLSearchParams(orderDetailsUrl.split('?')[1]).get('orderNumber') ?? '';

  return (
    <div className="sui-w-[24px] sui-h-[24px] sui-align-middle">
      <IconButton aria-describedby={id} onClick={handleClick} icon={More} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        placement="bottom-end"
      >
        <div className="sui-py-[8px] sui-px-[12px] tableMenuItem">
          <Link
            variant="body-sm"
            underline="none"
            href={orderDetailsUrl}
            onClick={() =>
              putAccountIdValueInSessionStorage(
                orderDetailsOrderNumber,
                accountIdValue,
                accountIdType,
              )
            }
          >
            View Order Details
          </Link>
        </div>
        {enableReceipt && (
          <div className="sui-py-[8px] sui-px-[12px] tableMenuItem">
            <ViewReceipt
              customerType={customerType}
              encryptedReceiptRequest={encryptedReceiptRequest}
              orderNumber={orderNumber}
              orderOrigin={orderOrigin}
              receiptImageSting={receiptImageSting}
              setAlertState={setAlertState}
              text="Download Receipt"
              underline={false}
              page="purchase-history"
            />
          </div>
        )}
        {customerType === 'b2b' && orderDetailsData && enableExportAndPrint && (
          <>
            <div className="sui-py-[8px] sui-px-[12px] tableMenuItem">
              <ExportButton
                orderDetailsData={orderDetailsData}
                setAlertState={setAlertState}
                layout="table"
              />
            </div>
            <div className="sui-py-[8px] sui-px-[12px] tableMenuItem">
              <PrintButton
                orderDetailsData={orderDetailsData}
                setAlertState={setAlertState}
                layout="table"
              />
            </div>
          </>
        )}
      </Popover>
    </div>
  );
};
